import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyAkPOO15tkro0r8X4LVyTJ05j1dA-doLuI",
  authDomain: "internal-voucher.firebaseapp.com",
  projectId: "internal-voucher",
  storageBucket: "internal-voucher.firebasestorage.app",
  messagingSenderId: "691862994163",
  appId: "1:691862994163:web:ad6f8296ddb283842c0b86"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection };  // Correct export
















